import Api from './BaseRequest';

const Update = (data) => {
    return Api.Put('/api/user/update', data)
};

const GetContacts = () => {
    return Api.Get('/api/user/contact');
}

const CreateContact = (data) => {
    return Api.Post('/api/user/contact/add', data);
}

const UpdatePassword = (data) => {
    return Api.Post('/api/user/password/update', data);
}

const UpdateContactAccess = (data) => {
    return Api.Put('/api/user/contact/toggleContactAccess', data);
}

const UploadProfilePicture = (imgFile) => {
    return Api.Post('/api/user/image', { img_upload: imgFile }, true, true);
}

export default {
    Update,
    GetContacts,
    CreateContact,
    UpdatePassword,
    UpdateContactAccess,
    UploadProfilePicture,
};
